import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=6a0089e4&scoped=true"
import script from "./goods.vue?vue&type=script&lang=js"
export * from "./goods.vue?vue&type=script&lang=js"
import style0 from "./goods.vue?vue&type=style&index=0&id=6a0089e4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0089e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a0089e4')) {
      api.createRecord('6a0089e4', component.options)
    } else {
      api.reload('6a0089e4', component.options)
    }
    module.hot.accept("./goods.vue?vue&type=template&id=6a0089e4&scoped=true", function () {
      api.rerender('6a0089e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/terminal_audit/form/components/goods/goods.vue"
export default component.exports